<template>
    <div class="customer-services">
        <img id="btn_udesk_im" @click="OpenCustomerServices" src="/static/images/kefu1.png" />
    </div>
</template>
<style scoped>
    .customer-services {
        position: fixed;
        right: 50px;
        bottom: 200px;
        cursor: pointer;
        z-index: 999999999999;
    }

    .customer-services img {
        width: 40px;
    }
</style>
<script>
    export default {
        data() {
            return {
                ContactList: {
                    ContactPhone: '',
                    ContactEmail: '',
                },
                Services: []
            }
        },
        computed: {
            CompanyID() {
                return this.$store.getters.ticketInfo.CompanyID;
            },
            UserID() {
                return this.$store.getters.ticketInfo.UserID;
            },
            UserName() {
                return this.$store.getters.ticketInfo.UserName;
            },
            CompanyName() {
                return this.$store.getters.ticketInfo.CompanyName;
            },
            RoleTypes() {
                return this.$store.getters.categorys.types.RoleType;
            },
        },
        watch: {
            'UserID'() {
                let __self = this;
                if (__self.UserID && __self.UserID != '') {
                    __self.__init();
                }
            }
        },
        methods: {
            getContactList() {
                let __self = this;
                let data = {
                    RoleID: __self.UserID
                }
                __self.$api.system.getContactList(data).then(function (json) {
                    if (json.data.isSucc) {
                        let result = _.find(json.data.result.entities, o => {
                            return o.IsDefault == 1150;
                        })
                        if (result) {
                            __self.ContactList = result;
                        }

                    }
                });
            },
            __init() {
                let __self = this;
                if (__self.CompanyID) {
                    let model = {
                        PageSize: 99999,
                        RoleType: __self.RoleTypes.Company,
                        RoleID: __self.CompanyID,
                        Superior: {
                            RoleType: __self.RoleTypes.User,
                            RootID: "S00000000120",
                        }
                    }
                    __self.$api.system.getOwners(model).then(o => {
                        if (o.data.isSucc) {
                            __self.Services = o.data.result;

                        }
                    })

                } else {
                    __self.Services = [];
                }
                __self.getContactList();

            },
            udInit() {
                let __self = this;
                let Tags = __self.Services.map(o => {
                    return o.UserName;
                });
                (function (a, h, c, b, f, g) {
                    a["UdeskApiObject"] = f;
                    a[f] = a[f] || function () {
                        (a[f].d = a[f].d || []).push(arguments)
                    };
                    g = h.createElement(c);
                    g.async = 1;
                    g.charset = "utf-8";
                    g.src = b;
                    c = h.getElementsByTagName(c)[0];
                    c.parentNode.insertBefore(g, c)
                })(window, document, "script", "https://assets-cli.s2.udesk.cn/im_client/js/udeskApi.js", "ud");
                let timestamp = new Date().getTime();
                function getNonceStr() {
                    return Math.random().toString(36).substr(2, 15);
                }
                let nonce = getNonceStr();
                var sign_str = `nonce=${nonce}&timestamp=${timestamp}&web_token=${__self.UserID ? __self.UserID : ''}&22d39dbf4792d4e66ea5d0b0308b5983`;
                sign_str = sha1(sign_str);
                sign_str = sign_str.toUpperCase();
                ud({
                    "code": "5b464e8",
                    "link": "https://lichengtrip.s2.udesk.cn/im_client/?web_plugin_id=4981",
                    "mode": "inner",
                    "color": "#307AE8",
                    "pos_flag": "srb",
                    "language": "zh-cn", //语言-中文
                    "session_key": "afeoqe",
                    "onlineText": "联系客服，在线咨询",
                    "offlineText": "客服下班，请留言",
                    "targetSelector": "#btn_udesk_im",
                    "selector": "#btn_udesk_im",
                });
                ud({
                    "customer": {
                        "nonce": nonce,
                        "signature": sign_str,
                        "timestamp": timestamp,
                        "c_name": __self.UserName ? __self.UserName : '',
                        "web_token": __self.UserID ? __self.UserID : '',
                        "customer_token": __self.UserID ? __self.UserID : '',
                        "c_org": __self.CompanyName ? __self.CompanyName : '',
                        "c_tags": Tags.join(','),
                        "c_phone": __self.ContactList.ContactPhone,
                        "c_email": __self.ContactList.ContactEmail,
                    }
                })
                ud({
                    "panel": {
                        "css": {
                            "bottom": "0",
                            "right": "180px"
                        },
                        "onToggle": function (data) { //面板开关时间
                            if (data.visible) {
                                console.log('窗口打开');
                            } else {
                                console.log('窗口关闭');
                            }
                        }
                    }
                });

            },
            OpenCustomerServices() {
                let __self = this;
                __self.udInit();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// customer-services.vue?097cfe2f